import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;
const API_URL = import.meta.env.VITE_API_URL;

const DeviceService = {
    getCode: async (target, deviceId) => axios.get(`${API_KEEPER}/app/devices/get-code?app=${target}&device_id=${deviceId}`).then(({data}) => data).catch(err => {throw err}),
    deviceExists: async (device) => axios.get(`${API_KEEPER}/user/device/exists/${device}`).then(({data}) => data).catch(err => {throw err}),
    list: async (data) => axios.post(API_URL + "/device/list", data ).then(({data}) => data).catch((err) => { throw err }),
    getById: async (id) => axios.get(`${API_URL}/getDevice/${id}`).then(({data}) => data).catch((err) => { throw err }),
    getOccurrenceId: async (id) => axios.get(`${API_URL}/device/getOccurrenceId/${id}`).then(({data}) => data).catch((err) => { throw err }),
    getMonitoramentoDevice: async (id) => axios.get(`${API_URL}/device/getMonitoramentoDevice/${id}`).then(({data}) => data).catch((err) => { throw err }),
    switchMonitoringDevice: async (id, target) => axios.post(`${API_KEEPER}/fact/occurrence/switchMonitoringDevice/${id}/${target}`).then(({data}) => data).catch((err) => { throw err }),
    getMonitoringDeviceStatus: async (id, target) => axios.post(`${API_KEEPER}/fact/occurrence/switchMonitoringDevice/status/${id}/${target}`).then(({data}) => data).catch((err) => { throw err }),

}

export default DeviceService;